import { useTranslation } from 'react-i18next';

import { DateFormat } from '@speeki/frontend-utils';

import { ArrElement } from '@@types/CommonTypes';

import { ColumnDefinitionType } from '@components/molecules/ListTable/ListTable';

import { GetSurveysForUserQuery } from '@graphql/generated/graphql';

type SurveysForUserNodes = ArrElement<GetSurveysForUserQuery['list']['nodes']>;

export const useGetColumns =
    (): ColumnDefinitionType<SurveysForUserNodes>[] => {
        const { t } = useTranslation();

        return [
            {
                flex: 5,
                isMain: true,
                key: 'name',
                label: t('SURVEY_LIST_HEADER_NAME'),
            },
            {
                customFormat: (data) => DateFormat.standard(data),
                flex: 1,
                key: 'endDate',
                label: t('SURVEY_LIST_HEADER_DATE'),
                minWidth: 90,
            },
        ];
    };
